import { Button, Menu, MenuItem } from '@trackman/web-shared-components';
import { useRef, useState } from 'react';

import { ReactComponent as ThreeDotsIcon } from 'svg/ThreeDots.svg';
import { useDownloadReport } from 'hooks/pdfHooks';
import { useTranslation } from 'react-i18next';
import { useTelemetry } from 'hooks/useTelemetry';
import { useReportViewModeStore } from 'stores/ReportViewModeStore';

type Props = {
  downloadName: string;
  setIsEditMode: (value: boolean) => void;
};

const MobileMenu = ({ downloadName, setIsEditMode }: Props) => {
  const { t } = useTranslation();
  const { mutate: downloadReport, isPending: isPreparingDownload } = useDownloadReport();
  const { setShowShelfForSingleViewMode } = useReportViewModeStore();
  const { trackEvent, events } = useTelemetry();

  const [open, setOpen] = useState(false);

  const anchorRef = useRef<HTMLButtonElement>(null);

  function handleDownload(format: 'letter' | 'a4'): void {
    downloadReport({ format, fileName: downloadName });
    trackEvent(events.DownloadedReport);
    setOpen(false);
  }

  function handleConfigureContent(): void {
    setIsEditMode(false);
    setShowShelfForSingleViewMode(true);
    setOpen(false);
  }

  function handleEditLayout(): void {
    setIsEditMode(true);
    setShowShelfForSingleViewMode(true);
    setOpen(false);
  }

  return (
    <div>
      <Button
        className='MobileMenu-btn'
        style={{ width: '40px', minWidth: '40px', padding: '0px' }}
        ref={anchorRef}
        onClick={() => setOpen((curr) => !curr)}
        isLoading={isPreparingDownload}
        disabled={isPreparingDownload}
        icon={() => <ThreeDotsIcon style={{ transform: 'rotate(90deg)', fill: '#414141' }} />}
      ></Button>
      <Menu open={open} anchorEl={anchorRef.current} onClose={() => setOpen(false)} style={{ marginTop: '6px' }}>
        <MenuItem label={t('Adjust report content')} onClick={handleConfigureContent} style={{ width: '200px' }} />
        <MenuItem label={t('Edit layout')} onClick={handleEditLayout} style={{ width: '200px' }} />
        <MenuItem label={t('Export report US Letter')} onClick={() => handleDownload('letter')} style={{ width: '200px' }} />
        <MenuItem label={t('Export report A4')} onClick={() => handleDownload('a4')} style={{ width: '200px' }} />
      </Menu>
    </div>
  );
};

export default MobileMenu;
